import { commonService } from '../services';
import { alertActions } from './alert';

const CODES_STORE_SUCCESS = 'codemng/CODES_STORE_SUCCESS';
const CODES_STORE_FAILURE = 'codemng/CODES_STORE_FAILURE';


const storeCodes = () => {
    return dispatch => {
        commonService.findGoupCodes()
        .then(response => {
            return response.data;
        })
        .then(groupCodes => {
            commonService.findAllCodeTree()
            .then(response => {
                dispatch(success(groupCodes, response.data));
            })
            .catch( error => {
                dispatch(failure(error.toString()));
                dispatch(alertActions.error(error.toString()));
            } ); 
        })
        .catch( error => {
            dispatch(failure(error.toString()));
            dispatch(alertActions.error(error.toString()));
        } ); 

        
    };

    function success(groupCodes, codes) { 
        localStorage.setItem('groupCodes', JSON.stringify(groupCodes));
        localStorage.setItem('codes', JSON.stringify(codes));
        return { type: CODES_STORE_SUCCESS, groupCodes, codes } 
    }
    function failure(error) { 
        return { type: CODES_STORE_FAILURE, error } 
    }
};

export const codemngActions = {
    storeCodes
};

const groupCodes = JSON.parse(localStorage.getItem('groupCodes'));
const codes = JSON.parse(localStorage.getItem('codes'));

const initialState = groupCodes && codes ? { groupCodes, codes } : {};

function codemng(state = initialState, action) {
    switch (action.type) {
        case CODES_STORE_SUCCESS:
            return {
                groupCodes: action.groupCodes,
                codes: action.codes
            };
        case CODES_STORE_FAILURE:
            return {};
        default:
            return state
    }
}

export default codemng;